<script lang="ts">
	import { onMount } from 'svelte';

	export let isOpen = false;
	export let notificationCount = 0;
	export let onClose: () => void;
	export let onToggle: () => void;
	export let notificationClassName: string = '';

	// Mock notifications data - in real app, this would come from a store or API
	const notifications = [
		{
			id: 1,
			title: 'โมเดล 3D ของคุณพร้อมแล้ว',
			message: 'การสร้างโมเดล "Sample Model" เสร็จสิ้นแล้ว',
			time: '5 นาทีที่แล้ว',
			isRead: false,
			type: 'success'
		},
		{
			id: 2,
			title: 'การอัปเดตระบบ',
			message: 'ระบบจะมีการปรับปรุงในวันที่ 10 ก.ค. 2025',
			time: '1 ชั่วโมงที่แล้ว',
			isRead: false,
			type: 'info'
		},
		{
			id: 3,
			title: 'โครงการใหม่ได้รับการอนุมัติ',
			message: 'โครงการ "Modern Design" ได้รับการอนุมัติแล้ว',
			time: '3 ชั่วโมงที่แล้ว',
			isRead: true,
			type: 'success'
		}
	];

	function markAsRead(notificationId: number) {
		// Mark notification as read (in real app, this would call API)
		console.log('Mark notification as read:', notificationId);
	}

	function markAllAsRead() {
		// Mark all notifications as read
		console.log('Mark all notifications as read');
		notificationCount = 0;
	}

	// Close dropdown when clicking outside
	function handleClickOutside(event: MouseEvent) {
		const target = event.target as Element;
		if (isOpen && !target?.closest('.notification-dropdown')) {
			onClose();
		}
	}

	onMount(() => {
		document.addEventListener('click', handleClickOutside);
		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	});
</script>

<div class="notification-dropdown">
	<button class="notification-btn" aria-label="Notifications" on:click={onToggle}>
		<i class="fas fa-bell"></i>
		{#if notificationCount > 0}
			<span class="notification-badge">{notificationCount}</span>
		{/if}
	</button>

	{#if isOpen}
		<div class="notification-menu {notificationClassName}">
			<div class="notification-header">
				<h4>การแจ้งเตือน</h4>
				{#if notificationCount > 0}
					<button class="mark-all-read" on:click={markAllAsRead}> อ่านทั้งหมด </button>
				{/if}
			</div>
			<div class="notification-list">
				{#each notifications as notification (notification.id)}
					<button
						class="notification-item {notification.isRead ? 'read' : 'unread'}"
						on:click={() => markAsRead(notification.id)}
						aria-label="Mark notification as read"
					>
						<div class="notification-icon {notification.type}">
							{#if notification.type === 'success'}
								<i class="fas fa-check-circle"></i>
							{:else if notification.type === 'info'}
								<i class="fas fa-info-circle"></i>
							{:else}
								<i class="fas fa-bell"></i>
							{/if}
						</div>
						<div class="notification-content">
							<h5>{notification.title}</h5>
							<p>{notification.message}</p>
							<span class="notification-time">{notification.time}</span>
						</div>
						{#if !notification.isRead}
							<div class="unread-dot"></div>
						{/if}
					</button>
				{/each}
			</div>
			<div class="notification-footer">
				<button class="view-all-btn">ดูทั้งหมด</button>
			</div>
		</div>
	{/if}
</div>

<style scoped>
	/* Notification Styles */
	.notification-dropdown {
		position: relative;
		display: inline-block;
		margin-right: 16px;
	}

	.notification-btn {
		position: relative;
		padding: 8px 12px;
		background: none;
		border: none;
		color: #fff;
		cursor: pointer;
		transition: all 0.3s ease;
		border-radius: 8px;
		font-size: 18px;
	}

	.notification-btn:hover {
		background: rgba(255, 255, 255, 0.1);
		color: #4a6cf7;
	}

	.notification-badge {
		position: absolute;
		top: 2px;
		right: 2px;
		background: #ff4444;
		color: #fff;
		border-radius: 50%;
		width: 18px;
		height: 18px;
		font-size: 11px;
		font-weight: 600;
		display: flex;
		align-items: center;
		justify-content: center;
		animation: pulse 2s infinite;
	}

	@keyframes pulse {
		0% {
			box-shadow: 0 0 0 0 rgba(255, 68, 68, 0.7);
		}
		70% {
			box-shadow: 0 0 0 10px rgba(255, 68, 68, 0);
		}
		100% {
			box-shadow: 0 0 0 0 rgba(255, 68, 68, 0);
		}
	}

	.notification-menu {
		position: absolute;
		top: 100%;
		right: 0;
		background: #060606;
		border-radius: 12px;
		box-shadow: 0px 0px 9px 3px rgba(255, 255, 255, 0.3);
		width: 380px;
		max-height: 500px;
		z-index: 1000;
		overflow: hidden;
		margin-top: 8px;
	}
	.notification-menu.mobile-notification-dropdown {
		padding: 0;
		/* margin-left: 0; */
		top: 40px;
		right: -49px;
		width: 260px;
		border-radius: 0px;
	}

	.notification-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 16px 20px;
		border-bottom: 1px solid #333;
		background: #0a0a0a;
	}

	.notification-header h4 {
		margin: 0;
		font-size: 16px;
		font-weight: 600;
		color: #fff;
	}

	.mark-all-read {
		background: none;
		border: none;
		color: #4a6cf7;
		cursor: pointer;
		font-size: 14px;
		font-weight: 500;
	}

	.mark-all-read:hover {
		text-decoration: underline;
	}

	.notification-list {
		max-height: 300px;
		overflow-y: auto;
	}

	.notification-item {
		display: flex;
		align-items: flex-start;
		gap: 12px;
		padding: 16px 20px;
		border-bottom: 1px solid #333;
		cursor: pointer;
		transition: background-color 0.2s ease;
		position: relative;
		background: none;
		border: none;
		width: 100%;
		text-align: left;
		font-family: inherit;
	}

	.notification-item:hover {
		background: rgba(255, 255, 255, 0.05);
	}

	.notification-item.unread {
		background: rgba(74, 108, 247, 0.15);
	}

	.notification-icon {
		width: 36px;
		height: 36px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		font-size: 16px;
		flex-shrink: 0;
	}

	.notification-icon.success {
		background: #28a745;
	}

	.notification-icon.info {
		background: #17a2b8;
	}

	.notification-content {
		flex: 1;
	}

	.notification-content h5 {
		margin: 0 0 4px 0;
		font-size: 14px;
		font-weight: 600;
		color: #fff;
	}

	.notification-content p {
		margin: 0 0 4px 0;
		font-size: 13px;
		color: #ccc;
		line-height: 1.4;
	}

	.notification-time {
		font-size: 12px;
		color: #999;
	}

	.unread-dot {
		width: 8px;
		height: 8px;
		background: #4a6cf7;
		border-radius: 50%;
		position: absolute;
		top: 20px;
		right: 16px;
	}

	.notification-footer {
		padding: 12px 20px;
		border-top: 1px solid #333;
		text-align: center;
		background: #0a0a0a;
	}

	.view-all-btn {
		background: none;
		border: none;
		color: #4a6cf7;
		cursor: pointer;
		font-size: 14px;
		font-weight: 500;
		width: 100%;
		padding: 8px;
		border-radius: 6px;
		transition: background-color 0.2s ease;
	}

	.view-all-btn:hover {
		background: rgba(74, 108, 247, 0.2);
	}
</style>
